import { ShippingDisplay } from '../../type/common.type';
import { PriceSummaryRow } from './parts/PriceSummaryRow';
import { PriceTotalRow } from './parts/PriceTotalRow';
import { Root } from './parts/Root';
import { ShippingFeeRow } from './parts/ShippingFeeRow';
import { Summary } from './parts/Summary';

interface TotalInfo {
  count: number;
  price: number;
  final_price: number;
  price_list: Array<{ price: number; count: number }>;
  general_price: number;
  zigzin_price_list: Array<{ price: number; count: number }>;
  zigzin_count: number;
  zigzin_price: number;
  shipping_display: ShippingDisplay;
}

interface PriceSummary {
  /** 쿠폰 할인 여부 */
  has_coupon_discount: boolean;
  /** 디지털 배송 여부 (배송비 없음) */
  is_digital_shipping: boolean;
  /** 총 가격 정보 */
  total_info: TotalInfo;
  /** 쿠폰 할인 금액 */
  coupon_discount_amount: number;
  /** 할인 정보 색상 */
  discount_color?: string;
  /** 최종 할인 정보 텍스트 */
  final_discount_text: string;
  /** 최종 가격 */
  final_price: number;
  /** 최종 가격 색상 */
  final_price_color: string;
}
export interface PriceSummaryProps {
  disabledCoupon?: boolean;
  priceSummary: PriceSummary;
}

export const PriceSummary = ({ disabledCoupon, priceSummary }: PriceSummaryProps) => {
  return (
    <PriceSummary.Root>
      {priceSummary.has_coupon_discount && (
        <PriceSummary.Summary>
          <PriceSummary.PriceSummaryRow label='총 금액' price={priceSummary.total_info.price} />
          {!disabledCoupon && (
            <PriceSummary.PriceSummaryRow
              label='쿠폰 할인'
              prefix_price='-'
              price={priceSummary.coupon_discount_amount}
              price_color={priceSummary.discount_color}
              style={{ marginTop: 8 }}
              tooltip_text={'결제 시에만 적용 가능한 쿠폰이 있을 경우,\n쿠폰 할인 금액이 지금보다 클 수 있습니다.'}
            />
          )}
        </PriceSummary.Summary>
      )}

      <PriceSummary.PriceTotalRow
        label='결제 예상 금액'
        price={priceSummary.final_price}
        price_color={priceSummary.final_price_color}
        discount_text={priceSummary.final_discount_text}
      />

      {!priceSummary.is_digital_shipping && (
        <PriceSummary.ShippingFeeRow
          mode={priceSummary.total_info.shipping_display.mode}
          text={priceSummary.total_info.shipping_display.text}
          left_name={priceSummary.total_info.shipping_display.left_name}
          left_value={priceSummary.total_info.shipping_display.left_value}
          right_name={priceSummary.total_info.shipping_display.right_name}
          right_value={priceSummary.total_info.shipping_display.right_value}
        />
      )}
    </PriceSummary.Root>
  );
};

PriceSummary.Root = Root;
PriceSummary.Summary = Summary;
PriceSummary.PriceSummaryRow = PriceSummaryRow;
PriceSummary.PriceTotalRow = PriceTotalRow;
PriceSummary.ShippingFeeRow = ShippingFeeRow;
